export const PHONE_DISPLAY = "438 978-9128";
export const PHONE_LINK = "tel:4389789128";
export const EMAIL = "info@pureva.ca";
export const ZONE = "Montréal et Rive-Sud";

export const PHOTOS = {
  hero: "https://images.unsplash.com/photo-1637730827702-de34e9ae4ede?auto=format&fit=crop&w=1920&q=85",
  why: "https://images.unsplash.com/photo-1572521165329-b197f9ea3da6?auto=format&fit=crop&w=1600&q=85",
  teaser:
    "https://images.unsplash.com/photo-1583953458882-302655b5c376?auto=format&fit=crop&w=1600&q=85",
  servicesBanner:
    "https://images.unsplash.com/photo-1742844552193-2fd3425cd26d?auto=format&fit=crop&w=1920&q=85",
  aboutBanner:
    "https://images.unsplash.com/photo-1646991761123-d83ce47c30c9?auto=format&fit=crop&w=1920&q=85",
  aboutStory:
    "https://images.unsplash.com/photo-1748764720733-3bb4c52ab6f9?auto=format&fit=crop&w=1600&q=85",
  aboutTeam:
    "https://images.unsplash.com/photo-1774953037913-af0cf688491a?auto=format&fit=crop&w=1600&q=85",
  contactBanner:
    "https://images.unsplash.com/photo-1758448093806-88b2089068ab?auto=format&fit=crop&w=1920&q=85",
};

export const SERVICES = [
  {
    slug: "aires-communes",
    name: "Aires communes",
    icon: "Building2",
    desc: "Halls, corridors, escaliers et ascenseurs : un entretien impeccable des espaces à fort passage.",
    image:
      "https://images.unsplash.com/photo-1758448656987-cfae6bf225e4?auto=format&fit=crop&w=1400&q=85",
    prestations: [
      "Nettoyage des halls d'entrée",
      "Entretien des corridors et des aires de circulation",
      "Nettoyage des escaliers et des paliers",
      "Entretien des ascenseurs et des surfaces touchées",
    ],
    lieux: [
      "Immeubles à bureaux",
      "Copropriétés gérées par un gestionnaire",
      "Halls d'entrée et déistributions",
    ],
    infos: [
      "La superficie approximative des aires communes",
      "Le nombre d'étages ou de tours desservies",
      "La fréquence d'intervention souhaitée",
      "Les heures d'accès au bâtiment",
    ],
  },
  {
    slug: "bureaux",
    name: "Bureaux",
    icon: "Briefcase",
    desc: "Postes de travail, salles de réunion, sanitaires et espaces partagés.",
    image:
      "https://images.unsplash.com/photo-1637665627832-dcd730049fbb?auto=format&fit=crop&w=1400&q=85",
    prestations: [
      "Nettoyage des postes de travail",
      "Entretien des salles de réunion",
      "Nettoyage des sanitaires",
      "Entretien des espaces partagés",
    ],
    lieux: [
      "Bureaux fermés et espaces de travail ouverts",
      "Salles de réunion",
      "Sanitaires",
      "Espaces partagés",
    ],
    infos: [
      "La superficie des lieux à entretenir",
      "Le nombre de postes ou de zones",
      "La fréquence d'intervention souhaitée",
      "Les heures d'accès aux bureaux",
    ],
  },
  {
    slug: "locaux-commerciaux",
    name: "Locaux commerciaux",
    icon: "Store",
    desc: "Entretien des surfaces et des espaces accueillant la clientèle.",
    image:
      "https://images.unsplash.com/photo-1769107805465-bfd41863f1a0?auto=format&fit=crop&w=1400&q=85",
    prestations: [
      "Entretien des surfaces de vente",
      "Nettoyage des espaces accueillant la clientèle",
      "Entretien régulier selon l'achalandage",
    ],
    lieux: [
      "Boutiques et commerces de détail",
      "Espaces de vente",
      "Zones d'accueil de la clientèle",
    ],
    infos: [
      "La superficie du local",
      "Les zones accueillant la clientèle",
      "La fréquence d'intervention souhaitée",
      "Les heures d'ouverture et d'accès",
    ],
  },
  {
    slug: "apres-construction",
    name: "Après construction",
    icon: "Hammer",
    desc: "Retrait des poussières de chantier et nettoyage de finition.",
    image:
      "https://images.unsplash.com/photo-1718816281270-ed6ef8357859?auto=format&fit=crop&w=1400&q=85",
    prestations: [
      "Retrait des poussières de chantier",
      "Nettoyage de finition des surfaces",
      "Préparation des lieux avant occupation",
    ],
    lieux: [
      "Locaux neufs ou réaménagés",
      "Espaces rénovés avant livraison",
    ],
    infos: [
      "L'état actuel des lieux",
      "La superficie à couvrir",
      "La date de livraison souhaitée",
      "Les accès à l'immeuble",
    ],
  },
  {
    slug: "tapis",
    name: "Tapis",
    icon: "Sofa",
    desc: "Nettoyage et entretien des tapis et moquettes, fibres ravivées.",
    image:
      "https://images.unsplash.com/photo-1768543939312-7bbab10cb347?auto=format&fit=crop&w=1400&q=85",
    prestations: [
      "Nettoyage des tapis et moquettes",
      "Entretien régulier des fibres",
      "Entretien des zones à forte circulation",
    ],
    lieux: ["Bureaux", "Aires communes", "Locaux commerciaux"],
    infos: [
      "La superficie de tapis ou de moquette",
      "Les zones à forte circulation",
      "La fréquence souhaitée",
    ],
  },
  {
    slug: "vitres",
    name: "Vitres",
    icon: "Droplets",
    desc: "Nettoyage des surfaces vitrées accessibles, sans traces.",
    image:
      "https://images.unsplash.com/photo-1775654063422-54e0a71578ad?auto=format&fit=crop&w=1400&q=85",
    prestations: [
      "Nettoyage des surfaces vitrées accessibles",
      "Nettoyage des vitrines",
      "Nettoyage des cloisons vitrées et des fenêtres",
    ],
    lieux: [
      "Vitrines de commerces",
      "Cloisons vitrées de bureaux",
      "Fenêtres accessibles",
    ],
    infos: [
      "Le nombre de surfaces vitrées",
      "Les hauteurs et l'accessibilité",
      "La fréquence souhaitée",
    ],
  },
  {
    slug: "garages",
    name: "Garages",
    icon: "Warehouse",
    desc: "Nettoyage des sols et des espaces de circulation.",
    image:
      "https://images.unsplash.com/photo-1642802434537-ace4629fcade?auto=format&fit=crop&w=1400&q=85",
    prestations: [
      "Nettoyage des sols de stationnement",
      "Entretien des espaces de circulation",
      "Nettoyage des aires d'accès",
    ],
    lieux: [
      "Stationnements intérieurs",
      "Rampes et aires d'accès",
      "Espaces de circulation",
    ],
    infos: [
      "La superficie du stationnement",
      "Le nombre de niveaux",
      "La fréquence souhaitée",
    ],
  },
];

export const FREQUENCES = [
  "Quotidienne",
  "Hebdomadaire",
  "Aux deux semaines",
  "Mensuelle",
  "Ponctuelle / Intervention unique",
];

export const PROCESS = [
  {
    step: "01",
    title: "Demande",
    desc: "Vous remplissez le formulaire ou nous contactez directement au 438 978-9128.",
  },
  {
    step: "02",
    title: "Évaluation des besoins",
    desc: "Nous analysons les lieux, leur superficie et le rythme d'intervention souhaité.",
  },
  {
    step: "03",
    title: "Soumission",
    desc: "Vous recevez une proposition claire, détaillée et adaptée à vos besoins.",
  },
  {
    step: "04",
    title: "Intervention",
    desc: "Nos équipes réalisent les travaux selon le calendrier convenu, avec rigueur.",
  },
];

export const serviceSlugToName = (slug) =>
  SERVICES.find((s) => s.slug === slug)?.name ?? "";
